// extracted by mini-css-extract-plugin
module.exports = {"option":"OptionSelect_option__WmHMV","dadosUsuario":"OptionSelect_dadosUsuario__3jBrZ","focado":"OptionSelect_focado__32Fnn"};